"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationWithModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactRedux = require("react-redux");
var Icons = _interopRequireWildcard(require("@olxbr/ds-icons"));
var _TipBox = _interopRequireDefault(require("../../../ui/TipBox"));
var _ModalTip = _interopRequireDefault(require("../../../containers/ModalTip"));
var _lurker = _interopRequireDefault(require("../../../../helpers/lurker"));
var _selectors = require("../../../../selectors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var NotificationWithModal = exports.NotificationWithModal = function NotificationWithModal(_ref) {
  var _tokens$modalLabel;
  var message = _ref.message,
    tokens = _ref.tokens,
    time = _ref.time,
    type = _ref.type,
    idMessage = _ref.idMessage,
    listId = _ref.listId;
  var Icon = Icons[tokens.icon];
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    openModal = _React$useState2[0],
    setOpenModal = _React$useState2[1];
  var sellerId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getSellerId)(state);
  });
  var buyerId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getBuyerId)(state);
  });
  var amISeller = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.amISeller)(state);
  });
  (0, _react.useEffect)(function () {
    _lurker["default"].viewTipEvent(type, {
      idMessage: idMessage,
      listId: listId,
      sellerId: sellerId,
      buyerId: buyerId,
      amISeller: amISeller
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
      tip: {
        onClick: function onClick() {
          return setOpenModal(!openModal);
        },
        cta: (_tokens$modalLabel = tokens === null || tokens === void 0 ? void 0 : tokens.modalLabel) !== null && _tokens$modalLabel !== void 0 ? _tokens$modalLabel : 'blablabla',
        title: tokens.title,
        icon: Icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}),
        text: message
      },
      time: time,
      variant: tokens === null || tokens === void 0 ? void 0 : tokens.variant
    }), openModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalTip["default"], _objectSpread(_objectSpread({}, tokens.modal), {}, {
      open: openModal,
      setOpen: setOpenModal
    }))]
  });
};
NotificationWithModal.propTypes = {
  message: _propTypes.string,
  tokens: _propTypes.object,
  notificationData: _propTypes.object,
  time: _propTypes.string,
  type: _propTypes.string,
  idMessage: _propTypes.string,
  listId: _propTypes.string
};